module.exports = __webpack_public_path__ + "img/background048.96ffb7fa.jpg";